import React from "react";
import { Main } from "./mainContainer.js";
import { Footer } from "../../shared/footer.js";
import { Navbar } from "../../shared/navbar.js";
export function Container() {
    return (React.createElement("div", null,
        React.createElement(Navbar, null),
        React.createElement(Main, null),
        React.createElement(Footer, null)));
}
